/*
 *
 * ReminderEmails constants
 *
 */

export const DEFAULT_ACTION = "app/ReminderEmails/DEFAULT_ACTION"

export const GET_CONFIGURATION_WATCHER =
  "app/ReminderEmails/GET_CONFIGURATION_WATCHER"
export const GET_CONFIGURATION_SUCCESS =
  "app/ReminderEmails/GET_CONFIGURATION_SUCCESS"
export const GET_CONFIGURATION_FAILED =
  "app/ReminderEmails/GET_CONFIGURATION_FAILED"

export const PUT_CONFIGURATION_WATCHER =
  "app/ReminderEmails/PUT_CONFIGURATION_WATCHER"
export const PUT_CONFIGURATION_SUCCESS =
  "app/ReminderEmails/PUT_CONFIGURATION_SUCCESS"
export const PUT_CONFIGURATION_FAILED =
  "app/ReminderEmails/PUT_CONFIGURATION_FAILED"
